export default __webpack_public_path__ + "static/media/about.6b4f1590.jpg";